import React from "react";

function CoverPage({ pillars, name, birthLine, reportNumber, genDate, dayStem, dayElemZh,
  strengthLabel, kwHasData, kwBranches, yongElem, result }) {
  return (
    <div className="lr2-cover" id="cover">
      <div className="lr2-cover-bg"/>
      <div className="lr2-cover-top">
        <div className="lr2-cover-brand">
          <div className="lr2-cover-brand-text">T H E&nbsp;&nbsp;L U M I N A A R C</div>
          <div className="lr2-cover-brand-line"/>
          <div className="lr2-cover-brand-sub">澄光能量</div>
        </div>
        <div className="lr2-cover-type">
          <div className="lr2-cover-type-zh">能量审计专业版报告</div>
          <div className="lr2-cover-type-en">ENERGY AUDIT PRO REPORT</div>
        </div>
      </div>
      <div className="lr2-cover-center">
        {/* 主品牌大字 */}
        <div style={{
          color:"#F5C842", fontSize:34, fontWeight:700, letterSpacing:".35em",
          marginBottom:6, textShadow:"0 2px 20px rgba(245,200,66,.4)"
        }}>澄 光 能 量</div>
        <div style={{
          color:"rgba(245,200,66,.5)", fontFamily:"sans-serif", fontSize:10,
          letterSpacing:".25em", marginBottom:24, textTransform:"uppercase"
        }}>THE LUMINAARC</div>
        {/* 印章（seal logo 或文字回退） */}
        <div style={{
          width:104,height:104,borderRadius:"50%",
          background:"#6B4F20",
          border:"1.5px solid rgba(245,200,66,.55)",
          boxShadow:"0 0 22px rgba(245,200,66,.22), inset 0 0 12px rgba(0,0,0,.3)",
          display:"flex",alignItems:"center",justifyContent:"center",
          marginBottom:20,overflow:"hidden",isolation:"isolate"
        }}>
          <img src="/logo_seal.png" alt="澄光能量印章"
               style={{width:104,height:104,display:"block",objectFit:"cover",
                       mixBlendMode:"screen",opacity:1}}
               onError={e=>{
                 const wrap=e.target.parentElement;
                 wrap.style.display='none';
                 const fb=wrap.nextSibling;
                 if(fb) fb.style.display='flex';
               }}/>
        </div>
        <div className="lr2-seal" style={{display:"none"}}><div>
          <span className="lr2-seal-zh">澄光能量</span>
          <span className="lr2-seal-en">THE LUMINAARC</span>
        </div></div>
        <div className="lr2-cover-name">{name||"—"}</div>
        <div className="lr2-cover-birth">{birthLine}</div>
        <div className="lr2-cover-pillars">
          {["year","month","day","hour"].map(p=>(
            <div key={p} className={"lr2-cover-pillar"+(p==="day"?" day":"")}>
              <span className="lr2-cover-pillar-gz">{pillars[p]?.gz||"—"}</span>
              <span className="lr2-cover-pillar-label">{({year:"年 柱",month:"月 柱",day:"日 柱 ✦ 日主",hour:"时 柱"})[p]}</span>
            </div>
          ))}
        </div>
        <div className="lr2-cover-tags">
          {dayStem && <span className="lr2-cover-tag">{dayStem}{dayElemZh}日主</span>}
          <span className="lr2-cover-tag">{strengthLabel}格局</span>
          {kwHasData && <span className="lr2-cover-tag">{kwBranches.join("")}空亡</span>}
        </div>
      </div>
      <div className="lr2-cover-divider"/>
      <div className="lr2-cover-bottom">
        <div className="lr2-cover-bottom-l">
          澄光能量 · 能量审计专业版报告<br/>
          lumarcai.com<br/>
          澄净智慧 · 自知自由
        </div>
        <div className="lr2-cover-bottom-r">
          报告编号 &nbsp;{reportNumber}<br/>
          生成日期 &nbsp;{genDate}<br/>
          版本 &nbsp;v2.0 · {result._source==="backend"?"PRO":"LOCAL"}
        </div>
      </div>
    </div>
  );
}

export default CoverPage;
